import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModal from '../../components/core/SMCModal';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import Api from '../../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import {useSMCSnackbar} from '../../utils/hooks';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {GatewayGetSchema} from '../../api/DBSchema/Gateway';
import RowLayout from '../../components/Layouts/RowLayout';

const whiteListUrlSchema = GatewayGetSchema.pages.threatPreventionExceptions.whiteListUrlSchema;

/**
 * Custom Sites Editor Modal
 * @param {Object} params
 * @param {Boolean} params.isOpen Is window open
 * @param {Integer} params.width 
 * @param {Integer} params.height
 * @param {Function} params.onCancel Window cancel function
 * @param {Function} params.onSuccess Success callback
 * @param {Object} params.defaultObject
 * @param {string} props.baseObjectName
 * @param {string} props.objectType
 */
function TPExceptionsWhitelistUrlEditorModal({
    isOpen = false,
    width = 300,
    height = 200,
    onCancel,
    onSuccess,
    defaultObject,
    baseObjectName,
    objectType,
    title
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();
    const { getErrorMessage } = useSMCErrorHandler();

    const [value, setValue] = useState('');
  
    const onFinish = async () => {
        const retVal = {
            [whiteListUrlSchema.value]: value,
        };
    
        try {
            await Api.validateTPExceptionsWhitelist(objectType, baseObjectName, retVal);
        } catch (e) {
            const errorMessage = getErrorMessage(e);
            enqueueErrorSnackbar(errorMessage, {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        onSuccess(retVal);
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            setValue('');
        }

        if (defaultObject) {
			setValue(defaultObject[whiteListUrlSchema.value]);
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onCancel}
            width={width}
            height={height}
            title={title}
        >
            <SMCModalBody style={{paddingLeft: '15px'}}>
                <RowLayout>
                    <SMCLabel>http(s)://</SMCLabel>
            		<SMCTextInput
						width={220}
						value={value}
						onChange={e => setValue(e.target.value)}
					/>
                </RowLayout>

            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default TPExceptionsWhitelistUrlEditorModal;